module.exports = __webpack_public_path__ + "static/media/boba.e2e71088.png";